import React from 'react';

import { FocusPanel } from '../focus-panel/FocusPanel.view';
import { Form, FormActions } from '../common/forms';
import PromiseButton from '../promise-button';

import { TestID } from 'src/testID';

import './ConnectMessages.scss';

export const AcceptInvitation: React.FC<{
  subId: string;
  onAccept?: (subId: string) => void;
  onDecline?: (subId: string) => void;
}> = ({ subId, onAccept, onDecline }) => (
  <FocusPanel testId={TestID.AcceptInvitation}>
    <div>
      <h2 className="connect-message-title">Invitation pending</h2>
      <p>Accept this invitation to access this subscription.</p>
    </div>
    <Form component="div">
      <FormActions>
        <PromiseButton
          onClick={() => onAccept?.(subId)}
          pending="Accepting…"
          disabled={false}
          data-testid={TestID.AcceptInvitationAcceptButton}
        >
          Accept
        </PromiseButton>
        <PromiseButton
          onClick={() => onDecline?.(subId)}
          pending="Declining…"
          disabled={false}
          data-testid={TestID.AcceptInvitationDeclineButton}
        >
          Decline
        </PromiseButton>
      </FormActions>
    </Form>
  </FocusPanel>
);
